import React from 'react';
import { Stack, Typography } from '@mui/material';
import CopyToClipboard from 'components/v2/shared/CopyToClipboard';
import TextEllipsis from 'components/v2/text/TextEllipsis';
import notifyHandler from 'utils/notifyHandler';

interface Props {
  message: string | React.JSX.Element;
  copyText: string;
  copyLabel?: string;
  duration?: number;
}

export const useToastMessageCopyable = (props: Props) => {
  const { message, copyText, copyLabel, duration = 10000 } = props;
  const isValidCopyText = typeof copyText === 'string' && copyText.length > 0;
  return notifyHandler({
    type: 'error',
    content: (
      <Stack direction="column" spacing={1}>
        <Typography>{message}</Typography>
        {isValidCopyText && (
          <CopyToClipboard
            content={
              <TextEllipsis rows={undefined} maxWidth={240} variant="body2" sx={{ fontSize: 12, color: 'gray' }}>
                {copyLabel || copyText}
              </TextEllipsis>
            }
            copyText={copyText}
          />
        )}
      </Stack>
    ),
    duration,
  });
};
